import {Stack} from "expo-router";
import WebHeader from "@/lib/headers/WebHeader";
import {Platform} from "react-native";
import ChatHeader from "@/lib/headers/ChatHeader";

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function StackLayout() {
    return (
        <Stack
            initialRouteName={"index"}
            screenOptions={{
                header: Platform.OS === "web" ? WebHeader : undefined,
                headerBackButtonDisplayMode: "minimal",
            }}
        >
            <Stack.Screen name="index" options={{title: "Chat"}}/>
            <Stack.Screen name="[chat_id]/index" options={{
                title: "Meldingslogg",
                keyboardHandlingEnabled: true,
                headerRight: ChatHeader,
            }}/>
            <Stack.Screen name="[chat_id]/edit" options={{title: "Innstillinger"}}/>
            <Stack.Screen name="[chat_id]/preferences" options={{title: "Varsling"}}/>
        </Stack>
    );
}